<template>
	<div class="addPerson tableSys pb05x" :class="{h25x:isMinHeight && flag}" @mouseenter="showPersonMousePos=true" @mouseleave="showPersonMousePos=false" v-clickoutside="handleClose">
		<div v-if="title" class="w6x taR cSub pr1x">{{title}}</div>
		<div class="posR drop-list-box">
			<transition-group tag="div" class="enableList  bdSub boxR-light cb tra ml05x_E pb05x mt05x_E fL_E" v-on:leave="el=>{transitionAction(el,'hide-x');}" :duration="500">
				<button v-if="temp.length>0&&allRomveFlag" class="clearTag hover-f-error hover-effect-rotate tra-fast" :key="'clear'" @click="clear" type="button">
					<div class="icoSys w1x h1x bgSub fSub fs16x">
						<Icon name="no" />
					</div>
				</button>
				<TagBox v-for="(person,index) in temp" :key="person.id" :styleType="'tag'" :val="person.name" :data="person" @Remove="onRemove(person,index)"></TagBox>
				<button :key="'add'" class="lh15 cMain showButton" type="button" @click.stop="getStructure" v-show="temp.length<maxNum">{{'+'+getLanguageStr('word1336','成员')}}</button>
			</transition-group>
			<div v-if="maxSelectTip" class="cWarning mt1x mb1x">{{maxSelectTip}}</div>
			<div class="drop-list clearfix" v-show="flag">
				<div class="l h20x-max" scroll>
					<v-tree ref="te" :data='treeData' v-show="treeData.length" @node-click="nodeClick" :tpl="tpl" />
				</div>
				<div class="r posR">
					<loading v-show="loading"></loading>
					<div class="h20x-max" scroll v-show="stayPersonList.length">
						<Checkbox :text="$t('cmd91',['全选'])" class="pl05x pt01x" :status="selectAllStatus" :triggerClick="false" @Click="checkAll" v-model="checkall"></Checkbox>
						<ul>
							<li v-for="(item,index) in stayPersonList" :key="item.id" class="vaM_E">
								<Checkbox @Click="selectData(item,index)" :index="index" v-model="item.checked" :text="item.name"></Checkbox>
							</li>
						</ul>
					</div>
					<div class="no-data" v-show="!stayPersonList.length">
						{{$t('word1380',['暂无数据'])}}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import * as lib from '@/util/lib'
import { getLanguageStr } from '@/util/language'
import clickoutside from '@/plugins/clickOutSide/index.js'
import InputText from '@/components/common/ui/InputText'
import VTree from '@/components/common/ui/vTree/Tree'
import Loading from '@/components/common/ui/Loading'
import TagBox from '@/components/common/ui/TagBox'
import Checkbox from '@/components/common/ui/Checkbox.vue'
import * as tree from '@/util/vTree'
import * as groupMemberApi from '@/api/manage/groupMember'

let timer = null
let closeDropTimer = null
const length = 50
export default {
	name: 'RelatedPerson',
	directives: { clickoutside },
	components: {
		InputText,
		VTree,
		Loading,
		TagBox,
		Checkbox
	},
	props: {
		title: {
			type: String,
			default: getLanguageStr('word1336', '成员')
		},
		maxSelect: {
			type: Array,	// [n,"language的填充key"] [1]可为空，则默认fill3rd75 选择的数量不能超过{0}
			default: function () { return new Array() }
		},
		allRomveFlag: {
			type: Boolean,
			default: true
		},
		isMinHeight: {
			type: Boolean,
			default: false
		},
		maxNum: {
			type: Number,
			default: 5
		},
		minNum: {
			type: Number,
			default: 0
		},
		oneDimensional: {
			type: Number,
			default: null
		},
		twoDimensional: {
			type: Number,
			default: null
		},
		initPersonData: {
			type: Array,
			default: () => ([])
		}
	},
	data () {
		return {
			showPersonMousePos: false,
			selectAllStatus: 0,
			flag: false,
			searchKey: '',
			treeData: [],
			result: [],
			stayPersonList: [],
			totalList: [],
			checkall: false,
			temp: [],
			requestData: {},
			currentGroup: {},
			personList: [],
			placeholderText: getLanguageStr('member1', '输入成员备注名'),
			maxSelectTip: '',
			readonly: false,
			loading: true
		}
	},
	created () {
		// this.getStructure()
	},
	methods: {
		transitionAction: lib.transitionAction,
		...mapActions({
			GetStructure: 'groupMember/GetStructure'
		}),
		handleClose (e) {
			if (!this.showPersonMousePos) {
				this.flag = false
			}
		},
		getLanguageStr,
		show () {
			this.$nextTick(() => {
				this.temp = _.cloneDeep(this.initPersonData)
			})
		},
		reset: function () {
			this.flag = false
			this.valueOf([])
		},
		tpl (node, ctx) {
			let titleClass = node.selected ? 'node-title node-selected' : 'node-title'
			if (node.searched) titleClass += ' node-searched'
			return (
				<div class="tpl">
				<span class={titleClass} title={node.title} id={`nodeTitle${node.id}`}
					//						domPropsInnerHTML={node.title.length > 10 ? node.title.substr(0,10)+'...' : node.title}
					onClick={() => {
						ctx.parent.nodeClick(ctx.props.node)
						// console.log(ctx.parent.getSelectedNodes())
					}}>{node.title.length > 10 ? node.title.substr(0, 10) + '...' : node.title}
				</span>
				<span class={titleClass} onClick={() => {
					ctx.parent.nodeClick(ctx.props.node)
				}}>({node.userCount})</span>
				</div>
			)
		},
		tagAction: function () { // $target,key
			this.$nextTick(function () {
				$('.addPerson .tagList .show').each(function () { // 侦听高级筛选条件，生成tagBox
					let $this = $(this)
					// app.tagMap[$this.attr("keyName")] = true;//登记生效条件
					let tW = $this.width()

					$this.css({
						transition: 'none',
						display: 'table',
						width: 0,
						opacity: 0,
						'margin-right': 0,
						'margin-top': 0
					}).removeClass('show').stop(true, true).animate({
						opacity: 1,
						width: tW,
						'margin-right': '1em',
						'margin-top': '1em'
					}, 200, function () { // 清空因动画产生的样式
						$this.css({
							transition: '',
							display: '',
							width: '',
							opacity: '',
							'margin-right': '',
							'margin-top': ''
						})
					})
				})
				$(".addPerson .tagList [class*='leave-active']").each(function () { // 侦听高级筛选条件，生成tagBox
					let $this = $(this)
					// delete app.tagMap[$this.attr("keyName")];
					$this.css({ 'transition': 'none' }).stop(true, true).animate({
						opacity: 0,
						width: 0,
						'margin-right': 0,
						'margin-top': 0
					}, 200, function () {
					})
				})
			})
		},
		search () {
			this.$refs.tree.searchNodes(this.searchword)
		},
		getList () {
			this.getStructure()
		},
		async getUserList (filter, type) {
			this.loading = true
			let result
			try {
				result = await groupMemberApi.getOrgUserList(filter)
				let { total } = result
				if (total == 0) {
					this.result = []
					this.stayPersonList = []
				} else {
					this.stayPersonList = []
					this.result = result.data
					if (type == 'all') {
						for (let i = 0; i < result.data.length; i++) {
							this.totalList[i] = {
								checked: true,
								id: result.data[i].orgUserDto.userInfo.id,
								name: result.data[i].orgUserDto.userInfo.name
							}
						}
					}
					for (let i = 0; i < this.result.length; i++) {
						this.stayPersonList[i] = {
							checked: false,
							id: this.result[i].orgUserDto.userInfo.id,
							name: this.result[i].orgUserDto.userInfo.name
						}
					}
					let y = this.temp.length
					if (y > 0) {
						for (let j = 0; j < this.temp.length; j++) {
							for (let n = 0; n < this.stayPersonList.length; n++) {
								// 请注意高级筛选时候传过来的值为字符串。
								if (this.temp[j].id == this.stayPersonList[n].id) {
									this.stayPersonList[n].checked = true
								}
							}
						}
						this.judgeCheckAll(this.stayPersonList)
					} else {
						this.selectAllStatus = 0
					}
				}
				this.$nextTick(() => {
					lib.fillHeight()
					this.loading = false
					lib.setScroll($('.addPerson [scroll]'))
				})
			} catch (error) {
				this.loading = false
				lib.setScroll($('.addPerson [scroll]'))
				!_.isEmpty(error) && this.$notify(error)
			}
		},
		getStructure (e) {	// 打开下拉时执行，输入搜索时直接执行getListByKey
			let buttonPermissions = JSON.parse(localStorage.getItem('buttonPermissions'))
			if (!this.flag) {	// 只有flag==flase的情况下查询
				if (buttonPermissions.includes('A/B/A13')) {
					this.loading = true
					this.GetStructure().then(() => {
						this.loading = false
						this.currentGroup = this.groupStructure[0]
						this.groupStructure.forEach((data, index) => {
							if (index == 0) {
								this.$set(data, 'selected', true)
							} else {
								this.$set(data, 'selected', false)
							}
							this.$set(data, 'expanded', true)
							this.$set(data, 'title', data.name)
						})
						let arr = tree.toTree(this.groupStructure)
						this.treeData = _.cloneDeep(arr)
						if (this.readonly) return
						if (!this.flag) {
							$('.drop-list').hide()
							$(e.target).parent().next().show()
							this.flag = true
							if (!this.searchKey) {	// 无搜索词
								this.getUserList({ 'page': 1, 'size': 100, 'order.direction': 'DESC', 'order.property': 'id', 'selectGroupId': this.currentGroup.id, 'name': '' }, 'all')
							} else {	// 有搜索词
								this.loading = false	// 提前loading(getListByKey有延时)
								this.getListByKey()
							}
						}
					}).catch(error => {
						!_.isEmpty(error) && this.$notify(error)
					})
				} else {
					if (!this.flag) {
						$('.drop-list').hide()
						$(e.target).parent().next().show()
						this.flag = true
						this.loading = false
						this.result = []
					}
				}
			}
			//    setTimeout(() => {
			//	        let obj = $(e.target).parents('.addPerson').find('.drop-list');//元素
			//			let h = obj.height();//元素高度
			//			let wh = $(window).height();//浏览器窗口高度
			//			let xh=wh-(h+obj.offset().top-$(document).scrollTop());
			//			if(xh<h){
			//			 	obj.css("top",`-${h}px`)
			//			}else{
			//				obj.css("top",`37px`)
			//			}
			//		}, 1000);
		},
		closeDrop () {
			this.flag = false
		},
		nodeClick (node) {
			this.currentGroup = node
			this.groupStructure.forEach(data => {
				this.$set(data, 'selected', false)
				this.$set(data, 'expanded', true)
				this.$set(data, 'title', data.name)
			})
			let index = this.groupStructure.findIndex(g => g.id === node.id)
			this.$set(this.groupStructure[index], 'selected', true)
			this.treeData = tree.toTree(this.groupStructure)
			this.requestData = {
				'page': 1,
				'size': 500,
				'order.direction': 'DESC',
				'order.property': 'id',
				'selectGroupId': this.currentGroup.id,
				'name': ''
			}
			this.requestData = { ...this.requestData, selectGroupId: node.id }
			this.getUserList(this.requestData)
		},
		uniqueArr (arr1, arr2) {
			// 合并两个数组
			arr1.push(...arr2)// 或者arr1 = [...arr1,...arr2]
			// 去重
			let arr3 = Array.from(new Set(arr1))// let arr3 = [...new Set(arr1)]
			return arr3
		},
		quchong (arr1, arr2) {
			let c = [...arr1, ...arr2], e = Array.from(new Set(c))
			return [...e.filter(_ => !arr1.includes(_)), ...e.filter(_ => !arr2.includes(_))]
		},
		checkAll () {
			let m = this.checkall
			let a = this.temp.map((item, index) => {
				return item.id
			})
			let b = this.stayPersonList.map((item, index) => {
				return item.id
			})
			if (m) {
				 let uniqueArr = this.uniqueArr(a, b)
				if (uniqueArr.length > this.maxNum) {
					this.$notify(i18n.t('fill3rd184', [this.maxNum, `成员不能超过${this.maxNum}个`]))
					this.$nextTick(() => {
						this.checkall = false
						if(this.temp.length>0){
							this.selectAllStatus = 1
						}else{
							this.selectAllStatus = 0
						}
					})
					return false
				} else {
					for (let a in this.stayPersonList) {
						this.stayPersonList[a].checked = m
					}
					let temptotal = this.uniqueArr(a, b)
					this.temp = []
					this.totalList.map((item, index) => {
						if (temptotal.indexOf(item.id) > -1) {
							this.temp.push(item)
						}
					})
					this.selectAllStatus = 2
				}
			} else {
				let removeDuplicates = this.quchong(a, b)
				if (removeDuplicates.length > this.minNum) {
						for (let a in this.stayPersonList) {
					this.stayPersonList[a].checked = m
				}
					this.temp = []
					this.totalList.map((item, index) => {
						if (removeDuplicates.indexOf(item.id) > -1) {
							this.temp.push(item)
						}
					})
					this.selectAllStatus = 0
				} else {
					this.$notify(getLanguageStr('phrase970', `至少选择${this.minNum}个成员`))
					return false
				}
			}
			this.tagAction()
			this.valueOf(this.temp)
		},
		// 根据关键词搜索
		getListByKey () {
			if (this.currentGroup.id && this.flag) {	// 已有分组信息且显示下拉时
				if (timer) clearTimeout(timer)
				timer = setTimeout(() => {
					this.requestData = { 'page': 1, 'size': 500, 'order.direction': 'DESC', 'order.property': 'id', 'selectGroupId': this.currentGroup.id, 'name': this.searchKey }
					this.requestData = { ...this.requestData, name: this.searchKey }
					this.getUserList(this.requestData)
				}, 50)
			}
		},
		onRemove (i, index) {
			var tempDeleteNum=0;
			if (this.minNum > 0 && this.temp.length == this.minNum) {
				this.$notify(getLanguageStr('phrase970', `至少选择${this.minNum}个成员`))
				return false
			} else {
				let pos = this.temp.indexOf(i)
				this.temp.splice(pos, 1)
				for (let n = 0; n < this.stayPersonList.length; n++) {
					if (this.stayPersonList[n].id === i.id) {
						this.stayPersonList[n].checked = false
						break
					}
				}
				this.stayPersonList.map((item,index)=>{
					if(item.checked){
							tempDeleteNum+=1
					}
				})
				if (tempDeleteNum == this.result.length) {
					this.selectAllStatus = 2
				} else if (tempDeleteNum ==0) {
					this.selectAllStatus = 0
				} else {
					this.selectAllStatus = 1
				}
				this.tagAction()
				this.valueOf(this.temp)
			}
		},
		isContained (a, b) {
			if (!(a instanceof Array) || !(b instanceof Array)) return false
			if (a.length < b.length) return false
			var aStr = a.toString()
			for (var i = 0, len = b.length; i < len; i++) {
				if (aStr.indexOf(b[i]) == -1) return false
			}
			return true
		},
		judgeCheckAll (l) {
			let a = this.temp.map((item, index) => {
				return item.id
			})
			let b = []
			let jishu = 0
			l.map((item, index) => {
				b[index] = item.id
				if (item.checked) {
					jishu = jishu + 1
				}
			})
			if (this.isContained(a, b)) { // 判断a数组是否包含b数组
				this.selectAllStatus = 2
				this.checkall = true
			} else {
				this.checkall = false
			}
			if (!this.checkall) {
				if (jishu == 0) {
					this.selectAllStatus = 0
				} else if (jishu < b.length) {
					this.selectAllStatus = 1
				} else {
					this.selectAllStatus = 2
				}
			}
		},
		selectData (i, index) {
			let checkT = 0
			this.stayPersonList.map((item, index) => {
				if (item.checked) {
					checkT += 1
				}
			})
			if (checkT > this.maxNum) {
				this.$notify(i18n.t('fill3rd184', [this.maxNum, `成员不能超过${this.maxNum}个`]))
				setTimeout(() => {
					this.stayPersonList[index] = i
					this.stayPersonList[index].checked = false
					this.stayPersonList = _.cloneDeep(this.stayPersonList)
					this.temp = _.cloneDeep(this.temp)
				}, 0)
				return false
			} else if (checkT < this.minNum && this.minNum > 0) {
				this.$notify(getLanguageStr('phrase970', `至少选择${this.minNum}个成员`))
				this.$nextTick(() => {
					this.$set(this.stayPersonList[index], 'checked', true)
				})
				return false
			} else {
				let cid = this.temp.map((item, index) => {
					return item.id
				})
				let pos = cid.indexOf(i.id)
				if (pos < 0) {
					if (this.maxNum > 0 && this.temp.length >= this.maxNum) {
						this.$notify(i18n.t('fill3rd184', [this.maxNum, `成员不能超过${this.maxNum}个`]))
						this.temp = _.cloneDeep(this.temp)
						return false
					} else {
						this.stayPersonList = _.cloneDeep(this.stayPersonList)
						this.temp.push(i)
					}
				} else {
					if (this.minNum > 0 && this.temp.length == this.minNum) {
						this.$notify(getLanguageStr('phrase970', `至少选择${this.minNum}个成员`))
						return false
					} else {
						this.stayPersonList = _.cloneDeep(this.stayPersonList)
						this.temp.splice(pos, 1)
					}
				}
				if (this.temp.length === this.result.length) {
					this.selectAllStatus = 2
					this.checkall = true
				} else if (this.temp.length > 0) {
					this.selectAllStatus = 1
					this.checkall = false
				} else {
					this.selectAllStatus = 0
					this.checkall = false
				}
				this.valueOf(this.temp)
			}
		},
		// 将值传给父。请注意当父为二维数组时需要确定下标。请参考消息管理默认规则设置
		valueOf (data) {
			let s = data.map((item, index) => {
				return item.id
			})
			let arr = [], nameArr = []
			data.map((item, index) => {
				arr[index] = { id: item.id, name: item.name }
				nameArr[index] = item.name
			})// 此数组用在展示id,name
			var obj = {}
			data.map(function (e, item) {
				obj[e.id] = e.name
			})
			if (this.oneDimensional != null) {
				this.$emit('Update', s, arr, this.oneDimensional, this.twoDimensional)
			} else {
				this.$emit('Update', s, obj, nameArr)
			}
			this.searchKey = ''
		},
		clear () {
			if (this.minNum > 0) {
				this.$notify(getLanguageStr('phrase970', `至少选择${this.minNum}个成员`))
				return false
			} else {
				this.temp = []
				this.selectAllStatus = 0
				this.checkall = false
				this.stayPersonList.forEach(el => {
					this.$set(el, 'checked', false)
				})
				this.valueOf(this.temp)
			}
		}
	},
	computed: {
		...mapGetters({
			userInfo: 'user/userInfo',
			groupStructure: 'groupMember/groupStructure'
		})
	},
	mounted () {
		if (this.initPersonData.length > 0) {
			this.temp = $.extend(true, [], this.initPersonData)
		} else {
			this.temp = []
		}
	}
}
</script>
<style lang="scss" scoped>
.drop-list {
	position: absolute;
	background: #fff;
	z-index: 10003;
	width: 100%;
	max-height: 25em;
	overflow: hidden;
	top: 37px;
	border-bottom-left-radius: 2px;
	border-bottom-right-radius: 2px;
	border: 1px solid rgba(0, 0, 0, 0.1);
	min-height: 4em;
	.l {
		width: 70%;
		height: 100%;
		float: left;
	}
	.r {
		width: 30%;
		height: 100%;
		float: left;
		padding-top: 0.5em;
		padding-bottom: 0.5em;
		border-left: 1px solid rgba(0, 0, 0, 0.1);
		li {
			list-style-type: none;
			line-height: 2em;
			height: 2em;
			text-overflow: ellipsis;
			white-space: nowrap;
			overflow: hidden;
			padding-left: 0.5em;
		}
	}
	.no-data {
		height: 100%;
		text-align: center;
		line-height: 4em;
	}
}
.tpl {
	display: inline-block;
}
.enableList {
	padding: {
		bottom: 0.5em;
	}
	position: relative;
	.clearTag {
		position: absolute;
		top: 0;
		right: 0.5em;
	}
}
.pt01x {
	padding-top: 1px;
}
.showButton {
	opacity: 1 !important;
	min-width: 7em;
	text-align: left;
	text-indent: 0.5em;
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/part/RelatedPerson.vue